import axios from 'axios'
import { urlParams } from '@common/loan-act/util'
import useragent from '@finance/useragent'
import { format } from '@finance/datetime'
import { getInstance } from '@finance/domain'
import { Base64 } from 'js-base64'
import cookie from 'js-cookie'
import { log } from './utils'


const ajax = axios.create({
  withCredentials: true
})

/**
 * 当前代码运行环境
 * LOCAL = 'local',
 * DEV = 'dev',
 * TEST = 'test',
 * UAT = 'uat',
 * PROD = 'prod',
 */
const ENV = getInstance().env

// 系统名称
const systemName = (() => {
  if (useragent.isAndroid) {
    return 'android OS'
  } else if (useragent.isIOS) {
    return 'iPhone OS'
  }
  return 'other'
})()

// 系统版本号
const systemVersion = (() => {
  if (useragent.isAndroid || useragent.isIOS) {
    return useragent.os.version
  }
  return 'unknown'
})()

const knCollectUrl = (() => {
  let url
  if (ENV === 'prod' || ENV === 'uat') {
    url = 'https://data.feidee.net/logCollect/events'
  } else {
    url = 'https://infras-dev.feidee.net/logCollect/events'
  }
  return url
})()

const ssjCollectUrl = (() => {
  let url
  if (ENV === 'prod' || ENV === 'uat') {
    url = 'https://dataapi.ssjlicai.com/log-collect/front-behaviour'
  } else {
    url = 'https://lcts5.ssjlicai.com/log-collect/front-behaviour'
  }
  return url
})()

// 上报数据结构模板
const knDataTpl = (params: object) => {
  const ssjData = window._ssjData || {}
  return {
    commons: {
      departmentID: 'riskctrl_sswl', // 部门id
      businessID: 'credit_behaviour', // 业务ID
      udid: ssjData.UUID || '', // 用户设备号
      systemName, // 系统名（iPhone OS等）
      cookieid: cookie.get('lc_cookieid') || '', // 没有udid时用户的唯一标示
    },
    events: [{
      dt: format(+new Date(), 'YYYY-MM-DD hh:mm:ss'), // 时间
      systemver: systemVersion,
      innermedia: cookie.get('lc_inner_media') || urlParams('inner_media') || '',
      userid: ssjData.userId || '',
      ...params,
    }]
  }
}

const ssjDataTpl = (params: { [x: string]: any }) => {
  const ssjData = window._ssjData || {}
  return {
    commons: {
      departmentID: 'financing', // 部门ID（财富）,由数据部门确定
      businessID: 'behaviour_common', // 业务ID,由数据部门确定
      udid: ssjData.UUID || '', // 用户设备号
      channel: ssjData.partnerCode || '', // 安装包渠道名称，iOS传空
      system_name: systemName || '', // 系统名称，[android OS、iPhone OS、other]
      system_version: systemVersion, // 系统版本，如10.0.1，7.0
      appName: ssjData.appName || '', // 终端名称，比如：MyMoney For Miui
      appVersion: useragent.app.version || '', // 终端版本号，比如10.0.4.5
      cookieid: cookie.get('lc_cookieid') || '', // 没有udid时用户的唯一标示
    },
    events: [{
      url: window.location.href, // 页面地址，浏览行为上传当前页面url，点击行为上传对象url
      referrer: document.referrer || '', // 访前页面，浏览该页面时的上一个页面
      useragent: window.navigator.userAgent, // 当前用户所使用的浏览器信息，由服务端获取

      session_id: ssjData.sessionId || '', // 无痕埋点会话id
      idfa: ssjData.idfa || '',
      sku: params.sku || '', // 流程名称
      order_id: params.orderId || '', // 订单号，产生订单交易时候上传
      amount: params.amount || '', // 购买金额
      product_id: params.productId || '', // 产品id

      inner_media: cookie.get('lc_inner_media') || '', // 内部媒体
      outer_media: cookie.get('lc_outer_media') || '', // 外部媒体参数
      client_id: cookie.get('clientId') || '', // 渠道号[01,04,12]
      sub_client_id: cookie.get('lc_sub_client') || '', // 二级渠道号[suishouji,suiguanjia,cardniu,yunzhijia,wechat,h5]
      adid: cookie.get('lc_adid') || '', // 广告ID
      cid: cookie.get('lc_cid') || '',
      appstoreid: cookie.get('lc_appstoreid') || '',

      page_name: params.pageName || params.page_name || '', // 流程步骤页名称
      title: params.title || document.title, // 页面标题/点击对象标题,浏览页面行为时上传页面标题，点击对象行为时上传点击对象标题，必填，不能为空
      etype: params.etype || '', // 动作类型,浏览页面还是点击对象 浏览：view 点击：click
      ...params,
    }]
  }
}

const encode = (url: string, data: object) => {
  const base64Str = Base64.encode(encodeURIComponent(JSON.stringify(data)))
  return `${url}?content=${base64Str}&em=eb`
}


export const knSendData = (params: object) => {
  const dataTpl = knDataTpl(params)
  log('卡牛埋点 =>', dataTpl)
  const url = encode(knCollectUrl, dataTpl)
  axios.get(url)
}

export const ssjSendData = (params: object) => {
  const dataTpl = ssjDataTpl(params)
  log('随手记埋点 =>', dataTpl)
  ajax.post(
    ssjCollectUrl,
    `content=${encodeURIComponent(JSON.stringify(dataTpl))}&em=n`,
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      }
    }
  ).catch((e) => {
    log('随手记埋点 接口异常 =>', e)
  })
}
